import { H3 } from "@/components/Headers/Headings";
import { useSurvey } from "@/contexts/Survey";
import { useTranslations } from "@/contexts/Translation";
import CopyValue from "../../CopyValue/CopyValue";
import { QRCodeSVG } from "qrcode.react";
import styles from "./Invites.module.css";
import { selfUrl } from "../../../lib/runtimeConfig";

const AnonymousInvites = () => {
  const t = useTranslations("invites");
  const { survey } = useSurvey();
  const respnderUrl = `${selfUrl()}/respond/?id=-${survey?.id}`;
  return (
    <>
      <H3>{t("anonymousInvites")}</H3>
      <p className={styles.anonymousInfo}>{t("anonymousInfo")}</p>
      <CopyValue testId='anonymous-response-url' label={t("anonymousInvites")} value={respnderUrl} />
      <div className={styles.qrCode}>
        <QRCodeSVG title={t("anonymousInvites")} marginSize={4} height='6em' width='6em' value={respnderUrl} />
      </div>
    </>
  );
};

export default AnonymousInvites;
